type CalendarDayProps = {
    date: string;
    isCurrentMonth: boolean;
    isSelected: boolean;
    isRangeDate: boolean;
    onDaySelected: (date: string) => void;
};

export default function CalendarDay({
    date,
    isCurrentMonth,
    isSelected,
    isRangeDate,
    onDaySelected,
}: CalendarDayProps) {
    const isCurrentMonthStyle = isCurrentMonth
        ? 'alli-text-blue-gray-700'
        : 'alli-text-gray-600';
    const isSelectedStyle = isSelected
        ? 'alli-bg-blue-600 alli-text-white hover:alli-bg-blue-600'
        : 'hover:alli-bg-gray-100';

    const isRangeDateStyle =
        isRangeDate && isSelectedStyle === 'hover:alli-bg-gray-100'
            ? 'alli-bg-blue-gray-50 alli-text-blue-gray-700'
            : '';

    return (
        <button
            type="button"
            onClick={() => onDaySelected(date)}
            disabled={!isCurrentMonth}
            className={`${isCurrentMonthStyle} alli-h-9 ${isRangeDateStyle} ${isSelectedStyle} `}>
            {parseInt(date.split('-')[2])}
        </button>
    );
}
